import { isPremiumUser, usePageData } from "@typeblind/pages-shared";
import { AdBanner } from "@typeblind/thirdparties";
import { PortalContainer, Toaster } from "@typeblind/widget";
import { type ReactNode } from "react";
import { CookieConsent } from "./CookieConsent.tsx";
import { Footer } from "./Footer.tsx";
import { NavMenu } from "./NavMenu.tsx";
import * as styles from "./Template.module.less";

export function Template({
  path,
  children,
}: {
  readonly path: string;
  readonly children: ReactNode;
}) {
  const { publicUser } = usePageData();
  return isPremiumUser(publicUser) ? (
    <div className={styles.bodyAlt}>
      <nav className={styles.navAlt}>
        <NavMenu currentPath={path} />
      </nav>
      <main className={styles.mainAlt}>
        {children}
        <Footer currentPath={path} />
        <PortalContainer />
        <Toaster />
      </main>
      <EnvName />
    </div>
  ) : (
    <div className={styles.body}>
      <nav className={styles.nav}>
        <NavMenu currentPath={path} />
      </nav>
      <div className={styles.topbar}>
        <AdBanner name="BANNER_970X90_1" />
      </div>
      <div className={styles.sidebar}>
        <AdBanner name="BANNER_160X600_1" />
      </div>
      <main className={styles.main}>
        {children}
        <Footer currentPath={path} />
        <PortalContainer />
        <Toaster />
      </main>
      <CookieConsent />
      <EnvName />
    </div>
  );
}

function EnvName() {
  return process.env.NODE_ENV === "production" ? null : (
    <div
      style={{
        position: "fixed",
        zIndex: "1",
        insetInlineEnd: "0px",
        insetBlockEnd: "0px",
        padding: "5px",
        margin: "5px",
        border: "1px solid red",
        color: "red",
      }}
    >
      {`process.env.NODE_ENV=${process.env.NODE_ENV}`}
    </div>
  );
}
